import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { css } from 'glamor';
import { StaticQuery, graphql } from 'gatsby';

import Header from '../components/header';
import Footer from '../components/footer';
import { BannerAd } from '../components/ad';

import logo from '../static/logo.jpg';

import '../static/css/bootstrap.min.css';
import '../static/css/input-range.css';

class Layout extends React.PureComponent {
    state = {
        showContent: true,
    }

    toggleContent = () => {
        this.setState(({ showContent }) => ({ showContent: !showContent }));
    }

    render() {
        const { children, pathname } = this.props;
        const { showContent } = this.state;
        
        return (
            <StaticQuery
                query={graphql`
                    query MetadataQuery {
                        allPrismicMetadata {
                            edges {
                                node {
                                    data {
                                        url
                                        keywords { keyword }
                                        description
                                    }
                                }
                            }
                        }
                    }
                `}
                render={({ allPrismicMetadata: { edges: metadata } }) => {
                    const pageMetadata = metadata.filter(md => md.node.data.url === pathname)[0];
                    let description = 'More Informed Financial Decisions';
                    let keywords = 'finance,investment,asset';
                    if (pageMetadata) {
                        description = pageMetadata.node.data.description;
                        keywords = pageMetadata.node.data.keywords.map(kw => kw.keyword).join(',');
                    }

                    return (
                        <div css={{
                            minHeight: '100vh',
                            display: 'flex',
                            flexDirection: 'column',
                        }}>
                            <Helmet
                                defaultTitle="Walletwyse"
                                titleTemplate="%s | Walletwyse"
                                meta={[
                                    { name: 'description', content: description },
                                    { name: 'keywords', content: keywords },
                                    { property: 'og:title', content: 'Walletwyse' },
                                    { property: 'og:image', content: logo },
                                ]}
                            />
                            <Header onToggleMobileNav={this.toggleContent} />
                            {/*<div css={{
                                marginTop: 24,
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                width: '100%',
                                maxWidth: 1024 }}
                            >
                                <BannerAd key={pathname} />
                            </div>*/}
                            <div css={{
                                flex: 1,
                                margin: '20px auto',
                                padding: '0 24px',
                                width: '100%',
                                maxWidth: 1024,
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: pathname === '/' ? '32px' : null,
                                '@media(max-width: 767px)': {
                                    display: showContent ? null : 'none',
                                    padding: '0 12px',
                                }
                            }}>
                                {children}
                            </div>
                            <Footer />
                        </div>
                    );
                }}
            />
        );
    }
};

export default Layout;
